/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CollaboratorResponse } from './collaboratorResponse';
import type { ProjectCreator } from './projectCreator';
import type { ProjectResponseAccessLevel } from './projectResponseAccessLevel';
import type { ProjectResponseStatus } from './projectResponseStatus';

export interface ProjectResponse {
  id: string;
  org_id: string;
  title: string;
  description?: string | null;
  status: ProjectResponseStatus;
  access_level: ProjectResponseAccessLevel;
  cover_image_url?: string | null;
  is_selected: boolean;
  created_by?: string | null;
  creator?: ProjectCreator | null;
  created_at: string;
  updated_at: string;
  is_owner?: boolean;
  can_edit?: boolean;
  job_count?: number;
  collaborators?: CollaboratorResponse[] | null;
}
